import {Component, NgZone, OnInit} from '@angular/core';
import {AppService} from '../app.service';
declare let paypal: any;
declare let $: any;

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['../app.component.css']
})
export class MainComponent implements OnInit {
  addScript = false;


  constructor(public app: AppService, private zone: NgZone) {

  }

  ngOnInit() {
    console.log("Starting up main component");
    this.app.isMobile = false; //initiate as false
    // testing url http://192.168.86.28:5000/#/?type=1&session=IA999HYV1Z9Q9QHH48WU3T3ACQAZBS&ID=390&app=2
    console.log("Window location: ", window.location);
    const hash = window.location.hash;
    console.log("Hash: ", window.location.hash);
    let type = 0;
    let passedSession = '';
    let id: number = -1;
    let app: number = -1;
    this.app.custom = -1;
    this.app.theme = 0;
    if (hash.indexOf('?') !== -1) {
      const parts = hash.split('?');
      console.log("Query: ", parts[1]);
      const pieces = parts[1].split('&');
      console.log("Parts: ", pieces);
      pieces.forEach((p) => {
        const q = p.split('=');
        if (q.length >= 2) {
          if (q[0] === 'type') {
            type = parseInt(q[1], 10);
          } else if (q[0] === 'session') {
            passedSession = q[1];
          } else if (q[0] === 'ID') {
            id = parseInt(q[1], 10);
          } else if (q[0] === 'app') {
            app = parseInt(q[1], 10);
          } else if (q[0] === 'custom') {
            this.app.custom = parseInt(q[1], 10);
          } else if (q[0] === 'theme') {
            this.app.theme = parseInt(q[1], 10);
          } else if (q[0] === 'currency') {
            this.app.currency = parseInt(q[1], 10);
          }
        }
      });
      console.log("Custom: ", this.app.custom, "Curr: ", this.app.currency, " Theme: ", this.app.theme);
      if (type === 1 && id > 0) {
        this.app.isMobile = true;
        this.app.setSession(passedSession);
        this.app.setUserID(id);
        this.app.isUnityEditing = true;
      }
    }
    this.app.game = app;
    if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
      || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4))) {
      if (this.app.isUnityEditing) {
        //Do nothing
      } else {
        //TODO: UNCOMMENT THIS
        // window.location.href = window.location.origin + "/create-card-backs/#/beta";
      }
      this.app.isAndroid = /android/i.test(navigator.userAgent);
      this.app.isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
      this.app.isMobile = true;
    } else {
      $('body').append('<script src="assets/Build/UnityLoader.js"></script>');
    }
    console.log("View type: ", type, " Passed Session: ", passedSession);
    console.log("Is it mobile? ", this.app.isMobile);

    console.log("Paypal initialized? : ", paypal);
    let session = this.app.getSessionID();
    console.log("SessionID: ", session);
    // tslint:disable-next-line: radix
    let userID = parseInt(this.app.getUserID());
    console.log("UserID: ", userID);
    if (!isNaN(userID)) {
      this.app.sessionLogin(userID, session).subscribe((user: any) => {
        console.log("User found: ", user);
        this.app.loggedIn = true;
        this.app.user = user;
        this.app.setSession(user.current_session);
        this.app.getAllCardsForUser();

        if (!this.app.user.verified && !this.app.isUnityEditing) {
          $('#verifyAccountModal').modal('show');
        }
        // if (user.tier === 100 || user.tier === 99) {
        //
        // } else {
        //   this.app.setUserID(null);
        //   $('#loginModal').modal('show');
        // }
      }, (error) => {
        console.log("User doese not exist: ", error);
        if (this.app.isMobile) {
          window.location.href = window.location.origin + "/#/beta";
          return;
        }
        this.app.setUserID(null);
      });
    } else {
      this.app.setUserID(null);
      $('#loginModal').modal('show');
    }
  }

  ngAfterViewChecked(): void {

  }

}
